import { PKCE_CONSTANTS } from '../../constants/PKCEConstants';
import { getStateCodeSpecificUrlUsingProcessEnv } from '../../helpers/navigationHelper';
import { IPKCERevokeTokenRequestParams } from '../models/PKCEAPIModels';
import utils, { IAPIHeaders } from '../utils';

const accessToken = () => ({
  getAccessToken: (data: string, headers: IAPIHeaders, isCa: boolean) => {
    const config = getStateCodeSpecificUrlUsingProcessEnv();
    // config.accessTokenUri is brand-resolved — correct for both BCBS and HealthSpring
    const accessTokenEndpoint = isCa ? config.accessTokenUriForCa : config.accessTokenUri;
    
    return utils.fetch(
      accessTokenEndpoint,
      {
        method: 'POST',
        data,
        headers,
      },
      PKCE_CONSTANTS.CONTENT_TYPE,
    );
  },
  getUserInfo: (headers?: IAPIHeaders) => {
    const { userInfoURL } = getStateCodeSpecificUrlUsingProcessEnv();
    return utils.fetch(userInfoURL, {
      method: 'GET',
      headers,
    });
  },
  logout: () => {
    const { logoutActiveMemberUri } = getStateCodeSpecificUrlUsingProcessEnv();
    return utils.fetch(logoutActiveMemberUri, {
      method: 'POST',
      headers: {
        'Accept-API-Version': PKCE_CONSTANTS.API_ACCEPT_HEADER_VALUE,
      },
      credentials: true,
    });
  },
  revokeToken: (data: IPKCERevokeTokenRequestParams) => {
    const { revokeAccessTokenUri } = getStateCodeSpecificUrlUsingProcessEnv();
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Accept-API-Version': PKCE_CONSTANTS.API_ACCEPT_HEADER_VALUE,
    };

    return utils.fetch(revokeAccessTokenUri, {
      method: 'POST',
      data,
      headers,
    });
  },
});

export default accessToken;
